<template>
	<div class="report-section device-section">
		<section-header :number="'01'" title="设备发展状况" />
		<div class="section-content">
			<div class="stats-grid" pdf-truncation-check-point>
				<stat-card
					label="本期新增"
					:value="data.addDeviceCount"
					:icon="benQiXinZeng"
					backgroundColor="#edf8fe"
					unit="台"
				/>
				<stat-card
					v-if="type !== 3"
					label="同比"
					:value="data.addDeviceRateYoy"
					unit="%"
					:trend="data.addDeviceRateYoy"
					:icon="tongBi"
					backgroundColor="#edf0ff"
				/>
				<stat-card
					label="环比"
					:value="data.addDeviceRateMom"
					unit="%"
					:trend="data.addDeviceRateMom"
					:icon="huanBi"
					backgroundColor="#ece4f7"
				/>
			</div>
			<!-- 设备状态表格 -->
			<div class="table-container" pdf-truncation-check-point>
				<table-base :columns="deviceStatusColumns" :data="data.typeClassifyDeviceCount || []" />
			</div>

			<!-- 图表行 -->
			<div class="charts-row">
				<Panel title="本期发展按客户类型分布" class="chart-container" pdf-truncation-check-point>
					<pie-chart :chart-options="deviceOnlineRateOptions" height="190px" />
				</Panel>
				<Panel title="本期发展按设备类型统计Top5" class="chart-container" pdf-truncation-check-point>
					<horizontal-bar-chart :chart-options="deviceModelDistributionOptions" height="190px" />
				</Panel>
			</div>

			<!-- 设备趋势图表 -->
			<Panel :title="lineTitle" class="chart-container full-width" pdf-truncation-check-point>
				<line-chart :chart-options="deviceTrendOptions" height="190px" />
			</Panel>
		</div>
	</div>
</template>

<script>
import TableBase from '../components/tableBase.vue'
import SectionHeader from '../components/SectionHeader.vue'
import StatCard from '../components/StatCard.vue'
import huanBi from '../icons/huanbi.png'
import tongBi from '../icons/tongbi.png'
import benQiXinZeng from '../icons/benqixinzeng.png'
import Panel from '../components/panel.vue'
import PieChart from '../components/pieChart.vue'
import HorizontalBarChart from '../components/horizontalBarChart.vue'
import LineChart from '../components/lineChart.vue'
import { fillMissingData, shouldRotate } from '../components/chartMixin'

const quarterMap = {
	1: '第一季度',
	2: '第二季度',
	3: '第三季度',
	4: '第四季度',
}

export default {
	name: 'DeviceSection',
	components: {
		TableBase,
		SectionHeader,
		StatCard,
		Panel,
		PieChart,
		HorizontalBarChart,
		LineChart,
	},
	props: {
		data: {
			type: Object,
			default: () => {},
		},
		type: {
			type: Number,
			default: 1,
		},
	},
	data() {
		return {
			benQiXinZeng,
			tongBi,
			huanBi,
		}
	},
	computed: {
		deviceStatusColumns() {
			if (this.type === 3) {
				return [
					{ prop: 'deviceClassifyName', label: '设备大类' },
					{ prop: 'count', label: '本期新增(台)', align: 'right' },
					{ prop: 'momCount', label: '上期新增(台)', align: 'right' },
					{ prop: 'momRate', label: '环比(%)', align: 'right' },
					{ prop: 'endCount', label: '累计已安装(台)', align: 'right' },
				]
			}
			return [
				{ prop: 'deviceClassifyName', label: '设备大类' },
				{ prop: 'count', label: '本期新增(台)', align: 'right' },
				{ prop: 'momCount', label: '上期新增(台)', align: 'right' },
				{ prop: 'momRate', label: '环比(%)', align: 'right', width: 80 },
				{ prop: 'yoyCount', label: '去年同期新增(台)', align: 'right', width: 120 },
				{ prop: 'yoyRate', label: '同比(%)', align: 'right', width: 80 },
				{ prop: 'endCount', label: '累计已安装(台)', align: 'right', width: 120 },
			]
		},
		lineTitle() {
			const type = this.type
			if (type === 1) {
				return `本期发展趋势`
			} else if (type === 2) {
				return `近一年发展趋势`
			} else if (type === 3) {
				return `近5年发展趋势`
			}
			return `本期发展趋势`
		},
		// 设备在线率饼图配置
		deviceOnlineRateOptions() {
			const data = (this.data.userTypeDeviceAddCount || []).filter(item => !!item.type)
			return {
				series: [
					{
						data: data.map(item => {
							return { value: item.count, name: item.type }
						}),
					},
				],
			}
		},

		// 设备型号分布柱状图配置
		deviceModelDistributionOptions() {
			const data = (this.data.deviceTypeDeviceAddCount || [])
				.sort((a, b) => b.count - a.count)
				.slice(0, 5)
				.sort((a, b) => a.count - b.count)
			return {
				yAxis: {
					data: data.map(item => item.type),
				},
				series: [
					{
						data: data.map(item => item.count),
					},
				],
			}
		},

		// 设备趋势折线图配置
		deviceTrendOptions() {
			let data = this.data.trendDeviceAddCount || []
			const type = this.type
			data = data.map(item => {
				if (type === 1) {
					item.name = item.type.split('-').slice(1).join('.')
				} else if (type === 2) {
					const [year, quarter] = item.type.split('-')
					const q = quarter.replace('季度', '')
					item.name = `${year}${quarterMap[q]}`
				} else if (type === 3) {
					item.name = item.type.split('-').pop() + '年'
				}
				return item
			})
			if (data.length) {
				const { year, dateSub } = this.data
				const fillList = []
				if (type === 1) {
					const month = dateSub < 10 ? '0' + dateSub : dateSub
					const endDate =
						this.dayjs(`${year}-${month}-01`).endOf('month').format('YYYY-MM-DD').split('-').pop() - 0
					for (let i = 1; i <= endDate; i++) {
						fillList.push(`${month}.${i < 10 ? '0' + i : i}`)
					}
				} else if (type === 2) {
					for (let q = 0; q < 4; q++) {
						let Q = dateSub - q
						const quarterYear = Q > 0 ? year : year - 1
						Q = Q > 0 ? Q : 4 + Q
						fillList.unshift(`${quarterYear}${quarterMap[Q]}`)
					}
				} else if (type === 3) {
					for (let y = 4; y >= 0; y--) {
						fillList.push(`${year - y}年`)
					}
				}
				data = fillMissingData(data, fillList, 'count')
			}
			return {
				grid: {
					top: shouldRotate([{ data }]) ? '14%' : '8%',
				},
				xAxis: {
					data: data.map(item => item.name),
				},
				series: [
					{
						data: data.map(item => item.count),
					},
				],
			}
		},
	},
}
</script>

<style scoped lang="scss">
.stats-grid {
	margin-bottom: var(--report-grid-gap);
}
</style>
